var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pg-login" }, [
    _c("div", { staticClass: "formularioLogin" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("form", { attrs: { action: "#" } }, [
        _c("span", { staticClass: "user" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email"
              }
            ],
            attrs: { type: "text", name: "email", placeholder: "E-mail" },
            domProps: { value: _vm.email },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.email = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-user" })
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "password" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password"
              }
            ],
            attrs: { type: "password", name: "password", placeholder: "Senha" },
            domProps: { value: _vm.password },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.password = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-lock" })
        ]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "button", value: "Entrar" },
          on: {
            click: function($event) {
              return _vm.login()
            }
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logoOnlysat" }, [
      _c("img", {
        attrs: {
          src: "/static/resources/images/logo.png",
          alt: "Logo Audiotext"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02fe9c5f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02fe9c5f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Auth/Authentication.vue
// module id = null
// module chunks = 